module.exports = __webpack_public_path__ + "img/15.9.TU.2ece2956.png";